module.exports = __webpack_public_path__ + "static/media/marker-icon.48dd18eb.svg";